import { BaseDataItemType, DataTableProps } from '@/components/DataTable/DataTable';
import { DataTable } from 'react-native-paper';
import { flattenObject } from 'flatten-anything';
import { StyleSheet } from 'react-native';
import { Color, FontFamily, FontSize } from '@/GlobalStyles';
import { BlurView } from 'expo-blur';
import { Fragment } from 'react';

type ListItemProps<T extends BaseDataItemType> = DataTableProps<T> & {
  item: T;
};

const ListItem = <T extends BaseDataItemType>(props: ListItemProps<T>) => {
  const { item, headers, keyExtractor, loading, onItemPress } = props;
  if (!item) {
    return null;
  }

  return (
    <DataTable.Row
      key={`${keyExtractor(item)}_row`}
      disabled={loading}
      onPress={() => onItemPress && onItemPress(item)}
    >
      {headers.map((hItem) => {
        return (
          <DataTable.Cell
            key={`${keyExtractor(item)}_${String(hItem.key)}`}
            style={[hItem.style]}
            textStyle={[styles.cellStyle, hItem.textStyle]}
          >
            {hItem.value
              ? hItem.value(item)
              : // @ts-ignore Volontairement ignoré mais les clés sont forcément des clé flatten par définition de headers
                flattenObject(item)[hItem.key]}
          </DataTable.Cell>
        );
      })}
      {loading ? <BlurView intensity={20} style={StyleSheet.absoluteFill} /> : null}
    </DataTable.Row>
  );
};

export default ListItem;

const styles = StyleSheet.create({
  cellStyle: {
    fontSize: FontSize.smallCapRegular_size,
    fontFamily: FontFamily.labelRegular,
    color: Color.MainGris,
  },
});
